import find from 'lodash/find';
import last from 'lodash/last';

import {splitFeatureName, iStartWith} from "../../../../misc/utils";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import {Part} from "./part";
import store from '../../../../store';
import {LayoutAbbreviation} from "../constants";
import {getFeatureIsLocked} from "../../../../misc/helpers";

const RgCabinetSize = /[0-9]+/g;

/**
 * Used for Complex parts such as Vanity, to perform some base functionality for related items
 */
export class IntermediatePart extends Part {

  constructor(isChild) {
    super(false, isChild);
    this.disabled = false;
    this.defaultDisabled = false; // used after reset click
    this.canBeDisabled = false;
  }

  /**
   * This will be called by the underlying vanity feature with a concrete instance of the part
   * @param dbFeature
   * @param part {Part}
   * @param setParent {boolean}
   * @param features
   */
  load_(dbFeature, part, setParent = true, features = 'features') {

    const {displayName, sharedFeatureName} = dbFeature;
    let {featureName} = splitFeatureName(displayName);
    if (!featureName && dbFeature.groupName && dbFeature.displayName) {
      featureName = dbFeature.displayName.replace(dbFeature.groupName + " - ", "")
    }

    // console.log('displayName:', displayName);

    if (setParent) {
      part.getParent = () => this;
      if (dbFeature.galleryImages) {
        const featured = dbFeature.galleryImages.find(galImage => galImage.featured);
        if (featured) {
          this.featuredImage = featured.url
        }
        dbFeature.galleryImages = dbFeature.galleryImages.sort((a, b) => b.default - a.default)
      }
    }

    if (iStartWith(displayName, 'Vanity -') || dbFeature.groupName === "Vanity") {
      if (displayName === "Vanity - Placeholder D[For=Custom]") {
        part.vanitySize = 72;
      } else {
        const fromName = sharedFeatureName || displayName || "";
        const lastDigit = last(fromName.match(RgCabinetSize));
        part.vanitySize = lastDigit ? lastDigit.slice(-2) : ''; // take two last digits from the name
      }

    }

    part.partName = featureName;
    part.metaData = dbFeature.metaData || {};
    part.dbFeature = dbFeature || {};
    if (!part.dbFeature.filterValueIDs) {
      part.dbFeature.filterValueIDs = {}
    }
    part.notAvailableInVisualizer = !dbFeature.s3Bindings || !dbFeature.s3Bindings.length || !dbFeature.s3Bindings.some(binding => binding.bucketName === "brv");

    let arrayOfBindings = [];
    if(dbFeature.s3Bindings) {
    dbFeature.s3Bindings.forEach((binding) => {
        if (!arrayOfBindings.includes("Small")
          && (binding.layout === LayoutAbbreviation.All || binding.layout === LayoutAbbreviation.Small)) {
          arrayOfBindings.push("Small");
        }
        if (!arrayOfBindings.includes("Large") &&
          (binding.layout === LayoutAbbreviation.All || binding.layout === LayoutAbbreviation.Large)) {
          arrayOfBindings.push("Large");
        }
      });
    }

    arrayOfBindings.forEach(layoutName => {
      this[features+"List"][layoutName].push(part);
    });

    if (part.notAvailableInVisualizer || !arrayOfBindings.length) { // features not in visualizer should be shown in the QuotingTool
      part.notAvailableInVisualizer = true;
      Object.keys(LayoutAbbreviation).forEach(layoutName => {
        if (layoutName !== "All") {
          this[features+"List"][layoutName].push(part);
        }
      })
    }

    this.loadFeatureCommon(part);

    return part
  }

  navigationSubItemsWithFilter(propName, propValue, featuresToCheck = this.features) {
    return featuresToCheck.filter((feature) => {
      return feature.matchesMetaForCondition(propName, propValue);
    }).map(_ => new DesignNavigationItem(_.featureName, _));
  }

  navigationSubItemsWithFilterMultipleConditions(arrayOfConditions, featuresToCheck = this.features) {
    // console.log('arrayOfConditions', arrayOfConditions);
    // console.log('featuresToCheck', featuresToCheck);
    return featuresToCheck.filter((feature) => {
      return feature.notAvailableInVisualizer || arrayOfConditions.every((conditionObject) => {
        const {propName, propValue} = conditionObject;

        let conditionPassed = feature.matchesMetaForCondition(propName, propValue);
        if (propName === "EX L" && !conditionPassed) {
          conditionPassed = feature.matchesMetaForCondition("Wall", propValue);
        }
        return conditionPassed

        // let {propName, propValue} = conditionObject;
        // const excludeProperty = propName.includes('-exclude');
        // if (excludeProperty) {
        //   propName = propName.split('-exclude')[0];
        // }
        // return excludeProperty
        //   ? feature.matchesMetaForCondition(propName, propValue)
        //   : feature.matchesMetaForCondition(propName, propValue)
      });
    })
  }

  // navigationSubItemsWithFilterMultipleConditionsWithInactive(arrayOfConditions, featuresToCheck = this.features) {   // shows all items & sets  not mathing array
  //   const refactoredArray = featuresToCheck.map((feature) => {
  //     feature.matchesMetaFailed = false;
  //     feature.matchesMetaFailedArray = [];
  //     arrayOfConditions.forEach((conditionObject) => {
  //       const {propName, propValue} = conditionObject;
  //       let conditionPassed = feature.matchesMetaForCondition(propName, propValue);
  //       if (propName === "EX L" && !conditionPassed) {
  //         conditionPassed = feature.matchesMetaForCondition("Wall", propValue);
  //       }
  //       if (!conditionPassed) {
  //         feature.matchesMetaFailed = true;
  //         feature.matchesMetaFailedArray.push(propName);
  //       }
  //     });
  //
  //     return feature
  //   });
  //   return orderBy(refactoredArray, ['matchesMetaFailed'],['asc']).map(_ => new DesignNavigationItem(_.featureName, _));
  // }

  setDefault() {
    if (!this.tryToSetTheSameFeature(this.features)) {
      this.activeFeature = this.features && this.features[0] || null;
      this.placeholderFeature = this.features && this.features.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("laceholder");
      });
    }
  }

  setLayers(layout) {
    if (!this.disabled) {
      if (!this.activeFeature) {
        this.setDefault(layout);
      }
      if (this.activeFeature && !this.activeFeature.notAvailableInVisualizer) {
        this.setFeatureLayer(this.activeFeature, layout);
        if (Array.isArray(this.activeFeatureParts) && this.activeFeatureParts.length) {
          this.activeFeatureParts.forEach((activeFeaturePart) => {
            this.setFeatureLayer(activeFeaturePart, layout);
          })
        }
      }
      if (this.placeholderFeature) {
        this.setFeatureLayer(this.placeholderFeature, layout);
      }
      if (this.shadowFeature) {
        this.setFeatureLayer(this.shadowFeature, layout);
      }
    } else {
      this.hideLayers();
    }
  }

  setFeatureLayer(currentFeature, layout) {
    // console.log('currentFeature', currentFeature);
    if (!currentFeature || !currentFeature.dbFeature)
      return; //feature no longer exists
    const layoutAbr = layout.getCurrentLayoutAbbreviation();

    let s3Binding = find(currentFeature.dbFeature.s3Bindings,
      {entityID: this.featureDefinitionId(currentFeature), layout: layoutAbr});
    if (!s3Binding) {
      s3Binding = find(currentFeature.dbFeature.s3Bindings,
        {entityID: this.featureDefinitionId(currentFeature), layout: LayoutAbbreviation.All});
    }
    // !!! we need to check, either a specific layout or ALL layout only !!!
    // if (!s3Binding) {
    //   s3Binding =  find(currentFeature.dbFeature.s3Bindings,
    //     {entityID: this.featureDefinitionId(currentFeature)});
    // }
    currentFeature.layer.fromS3Binding(s3Binding);
  }

  clickFromAllWalls(ignoreLocked) {
    this.handleClick(ignoreLocked, "all_walls");
  }

  tryToSetTheSameFeature(filteredFeatures, partName, placeholderName, shadowNeeded = false) {
    if (this.activeFeature) {
      const activeName = this.activeFeature.getSplittedFeatureName();
      this.activeFeature = filteredFeatures.find(feature => {
        const featureName = feature.getSplittedFeatureName();
        return activeName === featureName
      }) || null;
      // console.log('AF', filteredFeatures, this.activeFeature);
      this.placeholderFeature = filteredFeatures.find((feature) => {
        return placeholderName
          ? feature.dbFeature.displayName && feature.dbFeature.displayName.includesCI("placeholder")
          && feature.dbFeature.displayName.includes(placeholderName)
          : feature.dbFeature.displayName && feature.dbFeature.displayName.includesCI("placeholder")
      });
      if (shadowNeeded) {
        this.setShadowFeature();
      }
      if (this.activeFeature) {
        return true
      }
    }
    return false
  }

  /**
   * @param ignoreLocked {boolean}  // false by the default, is used by wizard ONLY
   */
  handleClick(ignoreLocked = false) {
    const parent = this.getParent();
    const {activeQuoteIndex} = store.getState().quotesState;
    parent.firstClick[activeQuoteIndex] = true; // allow to show active item
    const featureIsLocked = getFeatureIsLocked(this, ignoreLocked);
    if (featureIsLocked) {
      parent.activeLockedFeature = this;
    } else {
      if (parent.activeLockedFeature) {
        parent.activeLockedFeature = null;
      }
      this.featureClick();
    }
  }

  featureClick() {
    const parent = this.getParent();
    parent.placeholderChanged = true;
    if (this.notAvailableInVisualizer) {
      parent.activeNotInVisualizerFeature = this; // do not change the activeFeature (in order to keep the layer)
    } else if (parent.activeNotInVisualizerFeature) {
      parent.activeNotInVisualizerFeature = null; // remove it from other searches and so on
      parent.activeFeature = this;
    } else {
      parent.activeFeature = this;
    }
    this.featureClicked();
  }

  setShadowFeature() {
    const parentGroup = this.getParent();
    let filteredAvailableFeatures = [];
    if (parentGroup.shadows && parentGroup.shadows.features && parentGroup.shadows.features.length) {
      const layoutAbr = this.getParent().layout.getCurrentLayoutAbbreviation();
      const filteredFeatures = parentGroup.shadows.features.filter((shadow) => {
        return Array.isArray(shadow.dbFeature.s3Bindings) && shadow.dbFeature.s3Bindings.some(binding => {
          return binding.layout === LayoutAbbreviation.All || binding.layout === layoutAbr
        })
      });
      const compatibleFeatures = filteredFeatures.filter(shadowFeature => {
        return shadowFeature.partName && this.shadowName && shadowFeature.partName === this.shadowName
      });
      filteredAvailableFeatures = this.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), compatibleFeatures);
    }
    this.shadowFeature = filteredAvailableFeatures.length ? filteredAvailableFeatures[0] : null;
  }

  getFeatureWithMeta(featuresArray, metaName, metaValue) {
    return featuresArray.find((feature) => {
      return feature.metaData[metaName] && feature.metaData[metaName].includes(metaValue);
    });
  }

  getFeaturesWithMeta(featuresArray, metaName, metaValue) {
    return featuresArray.filter((feature) => {
      return feature.metaData[metaName] && feature.metaData[metaName].includes(metaValue);
    });
  }

  hideLayers() {
    if (this.activeFeature) {
      this.activeFeature.layer.src = '';
    }
    if (Array.isArray(this.activeFeatureParts) && this.activeFeatureParts.length) {
      this.activeFeatureParts.forEach((activeFeaturePart) => {
        if (activeFeaturePart && activeFeaturePart.layer) {
          activeFeaturePart.layer.src = '';
        }
      })
    }
    if (this.placeholderFeature) {
      this.placeholderFeature.layer.src = '';
    }
    if (this.shadowFeature) {
      this.shadowFeature.layer.src = '';
    }
  }

  /** shower door, fixture methods **/
  static getCurrentShowerBodyId(shower) {
    let currentShowerBodyId = "";
    const showerTubComboIsActive = shower.showerTubComboIsActive();
    if (!showerTubComboIsActive && shower.showerBody && shower.showerBody.activeFeature) {
      currentShowerBodyId = shower.showerBody.activeFeature.showerBodyId;
    } else if (showerTubComboIsActive && shower.layout.parts["Shower Tub Combo"]
      && shower.layout.parts["Shower Tub Combo"].wallConfiguration
      && shower.layout.parts["Shower Tub Combo"].wallConfiguration.activeFeature) {
      currentShowerBodyId = shower.layout.parts["Shower Tub Combo"].wallConfiguration.activeFeature.showerBodyId;
    }
    return currentShowerBodyId
  }

  rememberPreviousSelection(shower, currentActiveFeature) {
    const layoutAbbr = shower.layout.getCurrentLayoutAbbreviation();
    const currentShowerBodyId = IntermediatePart.getCurrentShowerBodyId(shower);
    const wallConfiguration = shower.layout.parts["Shower Tub Combo"] && shower.layout.parts["Shower Tub Combo"].wallConfiguration;
    if (this.currentShowerBodyId !== currentShowerBodyId && currentActiveFeature && !currentActiveFeature.partName.includes("laceholder")) {
      this.previouslySelectedFeatures[layoutAbbr][this.currentShowerBodyId] = currentActiveFeature; // remember previous active item
      if (wallConfiguration
        && wallConfiguration.features.some(feature => feature.showerBodyId === this.currentShowerBodyId)) {
        wallConfiguration.features.forEach((wallConfigurationFeature) => { // remember previous active item for all wall conf
          this.previouslySelectedFeatures[layoutAbbr][wallConfigurationFeature.showerBodyId] = currentActiveFeature;
        })
      }
    }
    this.currentShowerBodyId = currentShowerBodyId; // set new shower type
  }

  setDefaultAccordingToPreviousSelect(shower, filteredFeatures, hardCodedDefaultName, placeholderDefaultName = "laceholder") {
    const layoutAbbr = shower.layout.getCurrentLayoutAbbreviation();
    const currentShowerBodyId = IntermediatePart.getCurrentShowerBodyId(shower);
    // console.log('currentShowerBodyId', currentShowerBodyId);
    // console.log('this.previouslySelectedFeatures', this.previouslySelectedFeatures);

    if (this.currentShowerBodyId !== currentShowerBodyId && this.previouslySelectedFeatures[layoutAbbr][currentShowerBodyId]
      && filteredFeatures.some(f => f.dbFeature.id === this.previouslySelectedFeatures[layoutAbbr][currentShowerBodyId].dbFeature.id)) {
      this.activeFeature = this.previouslySelectedFeatures[layoutAbbr][currentShowerBodyId]; // restore from previous chosen
    } else {
      const hardCodedDefault = hardCodedDefaultName && filteredFeatures.find((feature) => {
        return !feature.notAvailableInVisualizer && feature.dbFeature.displayName && feature.dbFeature.displayName.includes(hardCodedDefaultName);
      });
      this.activeFeature = hardCodedDefault || filteredFeatures[0];
    }
    const placeholderDefault = filteredFeatures.find((feature) => {
      return !feature.notAvailableInVisualizer && feature.dbFeature.displayName
        && feature.dbFeature.displayName.includes(placeholderDefaultName);
    });
    this.placeholderFeature = placeholderDefault || null;
  }

  /**
   * Returns matching feature (for example: return Mirrors with the same Color and DoorStyle as current selected Vanity)
   * @param feature {object}  // current feature
   * @param activeFilterValueIDs {object}  // current activeFeature filters (that needed to be matched)
   * @param filter1 {object}  // featureGroup1
   * @param filter2 {object}  // featureGroup2
   */
  static featureHasFilters(feature, activeFilterValueIDs, filter1, filter2) {
    const filterValueIDs = feature.dbFeature && feature.dbFeature.filterValueIDs;
    if (filterValueIDs) {
      const hasValues = filterValueIDs[filter1.id]
        && filterValueIDs[filter2.id]
        && activeFilterValueIDs[filter1.id]
        && activeFilterValueIDs[filter2.id]
        && filterValueIDs[filter1.id].includes(activeFilterValueIDs[filter1.id][0])
        && filterValueIDs[filter2.id].includes(activeFilterValueIDs[filter2.id][0]);
      // hasValues ? console.log('match-', feature) : null;
      return hasValues || false // false is needed here, because true !> undefined
    }
    return false
  }

  getSplittedFeatureName = () => {
    if(this._customDisplayName == null) {
      this._customDisplayName = this.getFeatureName()
        // .replace(/ 30/g, "") // we can't do that since room layout change is broken after that
        // .replace(/ 60/g, "")
        // .replace(/ LG/g, "")
        // .replace(/ SM/g, "");
    }
    return this._customDisplayName
  };

  getCountertopGroupsSplittedFeatureName = () => {
    if (this._countertopGroupsCustomDisplayName == null) {
      this._countertopGroupsCustomDisplayName = this.dbFeature.sharedFeatureName;
    }
    return this._countertopGroupsCustomDisplayName
  };

  getMatchingFeatureName = () => {
    return this.getSplittedFeatureName()
  };

}
